// extracted by mini-css-extract-plugin
export default {"operationArea":"StaffManagement_operationArea__eYFw-","filterNav":"StaffManagement_filterNav__0l2HF"};